import { reducer as discountItemsList } from 'app/pages/DiscountsList/modules/DiscountItemsList';

export const reducers = {
    discountItemsList
};
